import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { numStringToCss } from '@bit/daviidli.corn-ui.utils';
const StyledImage = styled.img `
	height: ${p => p.Height};
	width: 100%;
	object-fit: cover;
	object-position: ${p => p.ObjectPosition};
`;
const CardImage = (props) => {
    const { className, height, objectPosition } = props;
    const imgProps = Object.assign(Object.assign({}, props), { children: null });
    return (React.createElement(StyledImage, Object.assign({ className: `corn-card-image ${className || ''}` }, imgProps, { Height: numStringToCss(height), ObjectPosition: objectPosition })));
};
CardImage.propTypes = {
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    objectPosition: PropTypes.string
};
CardImage.defaultProps = {
    height: 'auto',
    objectPosition: '50% 50%'
};
export default CardImage;
